module.exports = __webpack_public_path__ + "img/pol-skone.60dbae26.png";